import React, {useState} from 'react';
import Container from '@material-ui/core/Container';
import Grid from '@material-ui/core/Grid';
import {updateObject} from '../../shared/utility';
import GeoWigetBar from '../geoWigetBar/geoWigetBar';
import {
    StyledButton,
    StyledTextField,
} from '../styledMaterialComponents/styledMaterialComponents';
import {Typography} from '@material-ui/core';
import styles from './contactDetails.module.css';

const ContactDetails = ({contactDetails, updateContactDetails}) => {
    const [nameIsValid, setNameIsValid] = useState(false);
    const [nameWasTouched, setNameWasTouched] = useState(false);
    const [surnameIsValid, setSurnameIsValid] = useState(false);
    const [surnameWasTouched, setSurnameWasTouched] = useState(false);
    const [adressIsValid, setAdressIsValid] = useState(false);
    const [adressWasTouched, setAdressWasTouched] = useState(false);
    const [cityIsValid, setCityIsValid] = useState(false);
    const [cityWasTouched, setCityWasTouched] = useState(false);
    const [zipCodeIsValid, setZipCodeIsValid] = useState(false);
    const [zipCodeWasTouched, setZipCodeWasTouched] = useState(false);
    const [deliveryMethodIsValid, setDeliveryMethodIsValid] = useState(false);

    const validateText = text => {
        const pattern = /^(?!\s*$).+/;
        return pattern.test(text);
    };

    const validateZipCode = zipCode => {
        const pattern = /[0-9]{2}-[0-9]{3}/;
        return pattern.test(zipCode);
    };

    const validateDeliveryMethod = (deliveryMethod, inPostCode) => {
        if (deliveryMethod === 'PICKUP') {
            return true;
        } else if (deliveryMethod === 'INPOST') {
            if (inPostCode === '') {
                return false;
            } else {
                return true;
            }
        }
    };

    const onNameChanged = event => {
        const newName = event.target.value;
        setNameIsValid(validateText(newName));
        setNameWasTouched(true);
        const updatedDetails = updateObject(contactDetails, {
            name: newName,
        });
        const validatedDetailes = updateObject(updatedDetails, {
            isValid: checkValidation(updatedDetails),
        });
        updateContactDetails(validatedDetailes);
    };

    const onSurnameChanged = event => {
        const value = event.target.value;
        setSurnameIsValid(validateText(value));
        setSurnameWasTouched(true);
        const updatedDetails = updateObject(contactDetails, {
            surname: value,
        });
        const validatedDetailes = updateObject(updatedDetails, {
            isValid: checkValidation(updatedDetails),
        });
        updateContactDetails(validatedDetailes);
    };

    const onAdressChanged = event => {
        const value = event.target.value;
        setAdressIsValid(validateText(value));
        setAdressWasTouched(true);
        const updatedDetails = updateObject(contactDetails, {
            adress: value,
        });
        const validatedDetailes = updateObject(updatedDetails, {
            isValid: checkValidation(updatedDetails),
        });
        updateContactDetails(validatedDetailes);
    };

    const onCityChanged = event => {
        const value = event.target.value;
        setCityIsValid(validateText(value));
        setCityWasTouched(true);
        const updatedDetails = updateObject(contactDetails, {
            city: value,
        });
        const validatedDetailes = updateObject(updatedDetails, {
            isValid: checkValidation(updatedDetails),
        });
        updateContactDetails(validatedDetailes);
    };

    const onZipCodeChanged = event => {
        const value = event.target.value;
        setZipCodeIsValid(validateZipCode(value));
        setZipCodeWasTouched(true);
        const updatedDetails = updateObject(contactDetails, {
            zipCode: value,
        });
        const validatedDetailes = updateObject(updatedDetails, {
            isValid: checkValidation(updatedDetails),
        });
        updateContactDetails(validatedDetailes);
    };

    const onPackingMethodChanged = method => {
        const value = method;
        setDeliveryMethodIsValid(
            validateDeliveryMethod(value, contactDetails.inPostCode),
        );
        const updatedDetails = updateObject(contactDetails, {
            deliveryMethod: value,
        });
        const validatedDetailes = updateObject(updatedDetails, {
            isValid: checkValidation(updatedDetails),
        });
        updateContactDetails(validatedDetailes);
    };

    const onInPostCodeChanged = code => {
        const value = code;
        setDeliveryMethodIsValid(
            validateDeliveryMethod(contactDetails.deliveryMethod, value),
        );
        const updatedDetails = updateObject(contactDetails, {
            inPostCode: value,
        });
        const validatedDetailes = updateObject(updatedDetails, {
            isValid: checkValidation(updatedDetails),
        });
        updateContactDetails(validatedDetailes);
    };

    const checkValidation = updatedDetails => {
        if (
            validateText(updatedDetails.name) === true &&
            validateText(updatedDetails.surname) === true &&
            validateText(updatedDetails.adress) === true &&
            validateText(updatedDetails.city) === true &&
            validateZipCode(updatedDetails.zipCode) === true &&
            validateDeliveryMethod(
                updatedDetails.deliveryMethod,
                updatedDetails.inPostCode,
            ) === true
        ) {
            return true;
        } else {
            return false;
        }
    };

    const ShippingButtons = () => (
        <React.Fragment>
            <StyledButton
                variant={
                    contactDetails.deliveryMethod === 'PICKUP'
                        ? 'contained'
                        : 'outlined'
                }
                color="primary"
                size="large"
                onClick={() => {
                    onPackingMethodChanged('PICKUP');
                }}>
                <div className={styles.detailsButton}>
                    <Typography variant="h6">Odbiór osobisty</Typography>
                    <Typography variant="caption">
                        <>ZA DARMO</>
                    </Typography>
                </div>
            </StyledButton>
            <StyledButton
                variant={
                    contactDetails.deliveryMethod === 'INPOST'
                        ? 'contained'
                        : 'outlined'
                }
                color="primary"
                size="large"
                onClick={() => {
                    onPackingMethodChanged('INPOST');
                }}>
                <div className={styles.detailsButton}>
                    <Typography variant="h6">Paczkomat InPost</Typography>
                    <Typography variant="caption">
                        <>+15zł/mc</>
                    </Typography>
                </div>
            </StyledButton>
        </React.Fragment>
    );

    return (
        <Container maxWidth="sm">
            <Grid
                container
                spacing={2}
                justify="space-around"
                alignItems="center">
                <Grid
                    item
                    xs={12}
                    container
                    justify="space-around"
                    alignItems="center">
                    <h1>Dane kontaktowe</h1>
                </Grid>
                <Grid
                    item
                    xs={12}
                    container
                    justify="space-around"
                    alignItems="center">
                    <StyledTextField
                        value={contactDetails.name}
                        error={!nameIsValid && nameWasTouched}
                        id="name"
                        label="Imie"
                        variant="outlined"
                        onChange={event => {
                            onNameChanged(event);
                        }}
                    />
                </Grid>
                <Grid
                    item
                    xs={12}
                    container
                    justify="space-around"
                    alignItems="center">
                    <StyledTextField
                        value={contactDetails.surname}
                        error={!surnameIsValid && surnameWasTouched}
                        id="surname"
                        label="Nazwisko"
                        variant="outlined"
                        onChange={event => {
                            onSurnameChanged(event);
                        }}
                    />
                </Grid>
                <Grid
                    item
                    xs={12}
                    container
                    justify="space-around"
                    alignItems="center">
                    <StyledTextField
                        value={contactDetails.adress}
                        error={!adressIsValid && adressWasTouched}
                        id="adress"
                        label="Adres"
                        variant="outlined"
                        onChange={event => {
                            onAdressChanged(event);
                        }}
                    />
                </Grid>
                <Grid
                    item
                    xs={12}
                    container
                    justify="space-around"
                    alignItems="center">
                    <StyledTextField
                        value={contactDetails.city}
                        error={!cityIsValid && cityWasTouched}
                        id="city"
                        label="Miasto"
                        variant="outlined"
                        onChange={event => {
                            onCityChanged(event);
                        }}
                    />
                </Grid>
                <Grid
                    item
                    xs={12}
                    container
                    justify="space-around"
                    alignItems="center">
                    <StyledTextField
                        value={contactDetails.zipCode}
                        error={!zipCodeIsValid && zipCodeWasTouched}
                        id="zipCode"
                        label="Kod pocztowy"
                        variant="outlined"
                        onChange={event => {
                            onZipCodeChanged(event);
                        }}
                    />
                </Grid>
                <Grid
                    item
                    xs={12}
                    container
                    direction="row"
                    justify="space-around"
                    alignItems="center">
                    {<ShippingButtons />}
                </Grid>
                <Grid
                    item
                    xs={10}
                    container
                    direction="row"
                    justify="space-around"
                    alignItems="center">
                    {contactDetails.deliveryMethod === 'INPOST' && (
                        <GeoWigetBar setInpostCode={onInPostCodeChanged} />
                    )}
                </Grid>
            </Grid>
        </Container>
    );
};

export default ContactDetails;
